export default __webpack_public_path__ + "static/four-cf0dfa9d9d166ec81628fb4a248f8419.png";